// request.ts
import BaseService from '@/lib/BaseService'
import type { AxiosRequestConfig, AxiosResponse } from 'axios'

function request<Response = unknown, RequestData = unknown>(
    config: AxiosRequestConfig<RequestData>,
): Promise<AxiosResponse<Response>> {
    return BaseService.request<Response, AxiosResponse<Response>, RequestData>(
        config,
    )
}

export default request
